import { Link } from "react-router-dom";

function Contactus() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active"> Contact Us</li>
        </ul>
      </div>
      <div className="innersec container my-5 founder_message">
        <div className="row">
          <div class="col-lg-12">
            <h1> Contact Us </h1>

            <div class="row contact-container">

              <div class="col-lg-4">
                <div class="info-box">
                  <i class="fa-solid fa-envelope"></i>
                  <h3>Email</h3>
                  <p><a href="mailto:fajschool@gmail.com">fajschool@gmail.com</a></p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="info-box">
                  <i class="fa-solid fa-phone"></i>
                  <h3>Phone</h3>
                  <p><a href="tel: 080 22212386"> 080 22212386</a></p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="info-box">
                  <i class="fa-solid fa-location-dot"></i>
                  <h3>Address</h3>
                  <p><a href="https://maps.app.goo.gl/F3KfbC2onRkhuFDG8" target="_blank">   26, Wellington Street,
                    Richmond Town, Bangalore - 560025</a></p>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="map-container">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d7776.251189949486!2d77.5989719!3d12.9638142!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDU3JzQ3LjAiTiA3N8KwMzYnMTUuNCJF!5e0!3m2!1sen!2sin!4v1764648325892!5m2!1sen!2sin"
                    width="100%"
                    height="350"
                    style={{ border: 0 }}
                    allowfullscreen=""
                    loading="lazy">
                  </iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
export default Contactus;
